$( document ).ready(function() {
    if( $('.projects-grid__grid').length ){

        var filterValue = '*';

        if (get_current_page_id() == 213)
        {
            filterValue = "[data-category~='open']"
            $("#default-sort").addClass('focus-bg');
        }


        $('.projects-grid__grid').isotope({
            itemSelector: '.projects-grid__cell',
            layoutMode: 'fitRows',
            fitRows: {
                gutter: 0
            },
            filter: ':nth-child(-n+9)',
        })

        $('.projects-grid__filter').on( 'click', 'button', function() {

            if (get_current_page_id() == 213)
            {
                $("#default-sort").removeClass('focus-bg');
            }

            filterValue = $(this).attr('data-filter');


            if(filterValue == '*')
            {
                showLess();
            }
            else
            {
                $('.projects-grid__cell').removeClass('ani-slideup-start');
                $('.projects-grid__grid').isotope({ filter: filterValue  + ':nth-child(-n+999)'});
                $('#js-view-less').hide()
                $('#js-view-all').hide()
            }
        });

        function showLess(){
            $('.projects-grid__grid').isotope({ filter: filterValue  + ':nth-child(-n+9)'});
            $('#js-view-less').hide()
            $('#js-view-all').show()
        }

        function showMore(){
            $('.projects-grid__grid').isotope({ filter: filterValue  + ':nth-child(-n+999)'});
            $('#js-view-less').show()
            $('#js-view-all').hide()
        }

        $('#js-view-all').on( 'click', function() {
            showMore()
        });

        $('#js-view-less').on( 'click', function() {
            showLess()
        });

        showLess();

        
        console.log(get_current_page_id());
    }
});

function get_current_page_id() {
    var page_body = $('body.page');

    var id = 0;

    if(page_body) {
        var classList = page_body.attr('class').split(/\s+/);

        $.each(classList, function(index, item) {
            if (item.indexOf('page-id') >= 0) {
                var item_arr = item.split('-');
                id =  item_arr[item_arr.length -1];
                return false;
            }
        });
    }
    return id;
}